import { AuthUser } from '@supabase/supabase-js'
import Cookies from 'js-cookie'
import { create } from 'zustand'

const ACCESS_TOKEN = 'workstation_access_token'

interface AuthSession {
  access_token: string
  user: AuthUser | null
}

interface AuthState {
  auth: {
    user: AuthUser | null
    session: AuthSession | null
    setUser: (user: AuthUser | null) => void
    setSession: (session: AuthSession | null) => void
    accessToken: string
    setAccessToken: (accessToken: string) => void
    resetAccessToken: () => void
    reset: () => void
  }
}

export const useAuthStore = create<AuthState>()((set) => {
  const cookieState = Cookies.get(ACCESS_TOKEN)
  const initToken = cookieState || ''
  return {
    auth: {
      user: null,
      session: null,
      setUser: (user) =>
        set((state) => ({ ...state, auth: { ...state.auth, user } })),
      setSession: (session) =>
        set((state) => ({ ...state, auth: { ...state.auth, session } })),
      accessToken: initToken,
      setAccessToken: (accessToken) =>
        set((state) => {
          Cookies.set(ACCESS_TOKEN, accessToken)
          return { ...state, auth: { ...state.auth, accessToken } }
        }),
      resetAccessToken: () =>
        set((state) => {
          Cookies.remove(ACCESS_TOKEN)
          return { ...state, auth: { ...state.auth, accessToken: '' } }
        }),
      reset: () =>
        set((state) => {
          Cookies.remove(ACCESS_TOKEN)
          return {
            ...state,
            auth: { ...state.auth, user: null, accessToken: '', session: null },
          }
        }),
    },
  }
})
